/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Live_OpenInputs */



/**
* | output |
* | --- |
* | "Open the full demo" |
*
* @param {Landing_Live_OpenInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_live_open = /** @type {((inputs?: Landing_Live_OpenInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Live_OpenInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть полное демо")
	return /** @type {LocalizedString} */ ("Open the full demo")
});